<template>
  <el-backtop :target="scroll" :bottom="30">
    <div class="back-icon">
      <i class="el-icon-arrow-up" />
    </div>
  </el-backtop>
</template>

<script>
export default {
  name: 'BackTop',

  props: {
    scroll: {
      type: String,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.back-icon {
  width: 48px;
  height: 40px;
  background-color: #000000;
  opacity: 0.7;
  border-radius: 2px;
  .el-icon-arrow-up {
    padding: 8px 12px;
    font-size: 24px;
    color: #FFFFFF;
  }
}
</style>
